import {Prop} from 'vue-property-decorator';
import Button from "../Button";

/** Classe contenant les propriétés spécifiques aux boutons n'étant composés que d'une icône */
export default class ButtonLabel extends Button {
    /** Facultatif : ButtonInsideClass personnalisé */
    @Prop({default: () => ""})
    public ButtonInsideClass!: string | string[];

    /** Facultatif : Class attaché au label pour des besoins de debug */
    @Prop({default: () => ""})
    public ContentClass!: string | string[];

    /** Facultatif : Class attaché à l'icône pour des besoins de debug */
    @Prop({default: () => ""})
    public Label!: string | string[];
}